import { Card, SkeletonStack } from '@/shared/ui'
import { useAccount } from '@/entities/session'
import { useWorkingHours } from '@/entities/working-hours'
import { HoursForm } from '@/features/hours-edit'
import { timezoneLabel } from '@/shared/config/timezones'
import { nowInTimezone } from '@/shared/lib/time'

/** Вкладка настроек: когда агенту разрешено набирать номер. */
export function HoursPage() {
  const hours = useWorkingHours()
  const { data: account } = useAccount()

  return (
    <Card
      title="Часы звонков"
      subtitle={
        account
          ? // Пояс подписан прямо здесь: расписание без него читается
            // неоднозначно, а ошибка в поясе — это звонок в шесть утра.
            `Время в поясе «${timezoneLabel(account.company.timezone)}», сейчас там ${nowInTimezone(account.company.timezone)}`
          : undefined
      }
    >
      {hours.isPending ? (
        <SkeletonStack rows={7} height={36} />
      ) : hours.data ? (
        <HoursForm key={JSON.stringify(hours.data)} initial={hours.data} />
      ) : (
        <p>Не удалось загрузить расписание</p>
      )}
    </Card>
  )
}
